import { render, staticRenderFns } from "./Seperator.vue?vue&type=template&id=40a15986&scoped=true&"
var script = {}
import style0 from "./Seperator.vue?vue&type=style&index=0&id=40a15986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a15986",
  null
  
)

export default component.exports